import { EmploymentType } from '@borg/types';

class EmploymentTypesRepository extends Repository<EmploymentType> {
  getMany() {
    return this._getMany({ url: '/apps/employment-types' });
  }
}

export const employmentTypesRepository = new EmploymentTypesRepository();
